import { useState } from "react";
import { Link } from "react-router-dom";
import { films } from "@/mocks/films";
import { filmCategoryMeta } from "@/mocks/categories";
import type { FilmCategory } from "@/types";
import FilmCard from "@/components/base/FilmCard";
import SectionHeading from "@/components/base/SectionHeading";

const tabs: FilmCategory[] = ["movie", "tv", "variety"];

export default function FeaturedFilms() {
  const [active, setActive] = useState<FilmCategory>("movie");
  const list = films.filter((film) => film.category === active);

  return (
    <section className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
      <SectionHeading
        eyebrow="Featured"
        title="影视作品精选"
        desc="从院线大片到口碑剧集与热门综艺，挑选值得一看的优质内容。"
        action={
          <Link
            to={`/category/${active}`}
            className="hidden items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm font-medium text-foreground-700 transition-colors hover:border-accent-400 hover:text-accent-600 sm:inline-flex"
          >
            查看全部
            <i className="ri-arrow-right-line" />
          </Link>
        }
      />

      <div className="mb-6 inline-flex gap-1 rounded-full bg-background-100 p-1">
        {tabs.map((tab) => (
          <button
            key={tab}
            type="button"
            onClick={() => setActive(tab)}
            className={`whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-colors ${
              active === tab
                ? "bg-primary-500 text-background-50"
                : "text-foreground-600 hover:text-foreground-900"
            }`}
          >
            {filmCategoryMeta[tab].label}
          </button>
        ))}
      </div>

      <div className="grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-4 md:gap-5">
        {list.map((film) => (
          <FilmCard key={film.id} film={film} />
        ))}
      </div>

      <div className="mt-6 sm:hidden">
        <Link
          to={`/category/${active}`}
          className="flex items-center justify-center gap-1 rounded-md border border-background-300 px-4 py-2.5 text-sm font-medium text-foreground-700"
        >
          查看全部{filmCategoryMeta[active].label}
          <i className="ri-arrow-right-line" />
        </Link>
      </div>
    </section>
  );
}